import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Stack } from 'office-ui-fabric-react';
import styles from './ModuleContent.style';

const ModuleContent = ({ children, bottomBorder, className: classNameProp, ...other }) => {
  const className = clsx(styles.root, classNameProp, {
    [styles.bottomBorderPurple]: bottomBorder,
  });

  return (
    <Stack className={className} {...other}>
      {children}
    </Stack>
  );
};

ModuleContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  bottomBorder: PropTypes.bool,
};

ModuleContent.defaultProps = {
  className: '',
  bottomBorder: false,
};

export default ModuleContent;
